module.exports = function anonymous(it
/*``*/) {
var out='<div class="error_container" style="display: block; opacity: 1; z-index: 202;"> <div class="error_content"> <i class="error_img"></i> <div class="error_title">'+(it.message)+'</div> <p style="font-size: 12px">错误码: '+(it.errCode)+'</p> </div></div>';return out;
}